

































































import { defineComponent, computed, PropType } from "@nuxtjs/composition-api";
import CtaHeading from "components/theme/Content/CtaHeading.vue";
import { useImage } from "@wemade-vsf/composables";
import { SfCarousel, SfImage } from "@storefront-ui/vue";
import AgCarousel from "components/theme/AgCarousel.vue";

interface CarouselImage {
    image: string;
    caption: string;
    link: string;
}

export default defineComponent({
    name: "ImageCarousel",
    props: {
        images: {
            type: Array as PropType<Array<CarouselImage>>,
            default: () => [],
        },
        title: {
            type: String,
            default: "",
        },
        link: {
            type: String,
            default: "",
        },
        linkText: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    components: {
        SfImage,
        SfCarousel,
        CtaHeading,
        AgCarousel,
    },
    setup(props) {
        const { getMagentoImage } = useImage();
        const transformedImages = computed(() => {
            return props.images.map((i) => {
                i.image = i.image.startsWith("/") ? i.image : "/" + i.image;
                i.image = i.image.startsWith("/media")
                    ? i.image
                    : "/media" + i.image;
                i.image = getMagentoImage(i.image);
                return i;
            });
        });
        const sliderSettings = {
            perView: 3,
            focusAt: "center",
            gap: 0,
            peek: 0,
            breakpoints: {
                1023: {
                    perView: 1,
                    peek: 0,
                },
            },
        };

        return {
            sliderSettings,
            transformedImages,
            imagesCount: transformedImages.value.length,
        };
    },
});
